module.exports = __webpack_public_path__ + "img/landing2.1baae674.jpg";